"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLIP = exports.MUSIC = exports.WATERMARK = exports.CAPTION = void 0;
const CAPTION = 'caption';
exports.CAPTION = CAPTION;
const WATERMARK = 'watermark';
exports.WATERMARK = WATERMARK;
const MUSIC = 'music';
exports.MUSIC = MUSIC;
const CLIP = 'clip';
exports.CLIP = CLIP;